import gql from 'graphql-tag';

export const CREATE_DYNAMIC_AGENT_PHONE = gql`
    mutation createDynamicAgentPhone($input: DynamicAgentPhoneInput!) {
        createDynamicAgentPhone(input: $input) {
            ... on DynamicAgentPhoneResultError {
                errorCode
            }
            ... on DynamicAgentPhoneResultSuccess {
                phone
            }
        }
    }
`;
